import { VdsButton, VdsIcon, VdsIconButton } from '@volt/volt-extended-components-react';
import { useTranslation } from 'react-i18next';

export interface DeleteDialogButtonProps {
  disabled?: boolean;
  isIconButton?: boolean; // If true, render as an icon button instead of a full button.
}

const DeleteDialogButton = ({ isIconButton, disabled = false }: DeleteDialogButtonProps) => {
  const { t } = useTranslation();

  const slot = disabled ? undefined : 'dialog-trigger';

  return isIconButton ? (
    <VdsIconButton slot={slot} icon="trash" disabled={disabled} />
  ) : (
    <VdsButton
      slot={slot}
      variant="secondary"
      size="medium"
      isFullWidth={false}
      disabled={disabled}
    >
      {t('Delete')}
      <VdsIcon slot="icon-left" svgIcon="trash" />
    </VdsButton>
  );
};

export default DeleteDialogButton;
